import * as $ from 'jquery';
import * as i18n from 'CMS/core/i18n';
import Widget, { IWidgetInitializeOptions } from 'CMS/core/Widget';
import { WebPushHelper } from 'visuris/Helpers/WebPushHelper';


export default class NotificationSettings extends Widget {
    private $root: JQuery;
    private $notificationCheckbox: JQuery;

    public initialize(options: IWidgetInitializeOptions) {
        super.initialize(options);
        this.$root = $(options.root);

        this.$notificationCheckbox = this.$root.find('.notifications-checkbox');

        if (WebPushHelper.getLocalStorageValue(WebPushHelper.WEBPUSHENABLED) === 'true') {
            WebPushHelper.setNotificationCheckboxes(true);
        }
        if (Notification.permission !== 'granted') {
            WebPushHelper.setNotificationBlockedTextVisibility(true);
        }

        this.$notificationCheckbox.on('change', async (e: any) => {
            WebPushHelper.setLocalStorageValue(WebPushHelper.WEBPUSHENABLED, e.target.checked.toString());
            if (e.target.checked) {
                if (Notification.permission === 'default') {
                    WebPushHelper.setNotificationCheckboxes(true);
                    // request permission if default(ask)
                    const permission = await Notification.requestPermission();
                    if (permission === 'granted') {
                        await WebPushHelper.initializeSubscription();
                    } else {
                        // show permission denied / not granted
                        WebPushHelper.setNotificationBlockedTextVisibility(true);
                    }
                } else if (Notification.permission === 'denied') {
                    // permission denied -> set all checkboxes and show warning text
                    WebPushHelper.setNotificationCheckboxes(true);
                    WebPushHelper.setNotificationBlockedTextVisibility(true);
                } else {
                    // permission granted -> subscribe
                    await WebPushHelper.initializeSubscription();
                }
            } else {
                // unsubscribe
                await WebPushHelper.initializeSubscription();
            }
        });

        i18n.bind(this.$root);
    }
}